module.exports = __webpack_public_path__ + "static/img/2.0e6c101.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/laboratory/2.jpg
// module id = /VVd
// module chunks = 1